import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MediaContext = createContext({ media: {}, refresh: () => {} });

export const MediaProvider = ({ children }) => {
  const [media, setMedia] = useState({});
  const refresh = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/media`);
      const raw = res.data || {};
      const resolved = {};
      Object.entries(raw).forEach(([k, v]) => {
        resolved[k] = v.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${v}` : v;
      });
      setMedia(resolved);
    } catch {
      setMedia({});
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  const value = useMemo(() => ({ media, refresh }), [media, refresh]);
  return <MediaContext.Provider value={value}>{children}</MediaContext.Provider>;
};

export const useMedia = () => {
  const { media } = useContext(MediaContext);
  return (slot, fallback) => media[slot] || fallback;
};

export const useMediaContext = () => useContext(MediaContext);
